import type { SVGProps } from 'react';

interface AwsPrisezIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const AwsPrisezIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & AwsPrisezIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 47 47"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#aws-prisez_svg__a)">
      <path
        d="M6.01 9.837V7.651a2.733 2.733 0 0 1 2.732-2.733h32.244a2.733 2.733 0 0 1 2.733 2.733v2.186M6.01 40.989v2.186a2.733 2.733 0 0 0 2.732 2.732h32.244a2.733 2.733 0 0 0 2.733-2.732v-2.186"
        stroke="#4FA9FF"
        strokeLinecap="round"
        strokeWidth={2.186}
      />
      <g clipPath="url(#aws-prisez_svg__b)">
        <path
          d="M24.8 15.758v4.098h-1.822a1.48 1.48 0 0 1-1.48-1.48v-2.619zm3.985 0v2.618a1.48 1.48 0 0 1-1.48 1.48h-1.822v-4.099zm-2.505-5.01a1.48 1.48 0 0 1 1.247 2.278l1.144-.001c.315 0 .57.212.57.474v1.329c0 .262-.255.474-.57.474h-3.188v-2.277H24.8v2.277h-3.188c-.314 0-.569-.212-.569-.474V13.5c0-.263.255-.475.57-.475h1.143a1.48 1.48 0 0 1 2.386-1.742 1.48 1.48 0 0 1 1.138-.535m-2.277.683a.797.797 0 0 0-.065 1.591l.065.003h.797v-.797l-.003-.066a.797.797 0 0 0-.794-.731m2.277 0a.797.797 0 0 0-.797.797v.797h.797a.797.797 0 0 0 0-1.594"
          fill="#B0CEFC"
        />
      </g>
      <path
        d="M26.952 26.78h1.462a10.3 10.3 0 0 0-2.905-3.164.66.66 0 0 0-.75 0 10.2 10.2 0 0 0-2.904 3.163zM17.985 36.2c0 .005.046.182.043.187l1.151 4.62a.624.624 0 0 0 1.163.2l1.92-3.45h1.413l.456 2.218v.001a.827.827 0 0 0 1.626-.025l.375-2.193h1.326l1.925 3.451v-.001a.628.628 0 0 0 1.15-.15l1.688-6.794a.625.625 0 0 0-.287-.691l-2.414-1.428a10.8 10.8 0 0 0-.782-3.726c-1.792-.001-5.96.002-7.753 0a10.8 10.8 0 0 0-.78 3.726l-2.413 1.428a.62.62 0 0 0-.288.69zm6.877-6.957a2.32 2.32 0 0 1 2.288 2.325 2.32 2.32 0 0 1-2.288 2.325 2.32 2.32 0 0 1-2.286-2.325 2.32 2.32 0 0 1 2.286-2.325"
        fill="#B0CEFC"
      />
    </g>
    <defs>
      <clipPath id="aws-prisez_svg__a">
        <path d="M0 0h47v46.453H0z" fill="#fff" />
      </clipPath>
      <clipPath id="aws-prisez_svg__b">
        <path d="M19.672 9.837h10.93v10.93h-10.93z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
